// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopularItem_wrapper__3ZI4v","image":"PopularItem_image__KLvd8","title":"PopularItem_title__Dwc3I","date":"PopularItem_date__2T5CD"};